import React, { useEffect, useState } from "react";
import { Drawer, notification, Checkbox, Row, Col, Form, Collapse, Input, Button, Tabs, Spin } from "antd";
import { RollbackOutlined, KeyOutlined, CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import CustomScrollbars from "util/CustomScrollbars";

import ContactList from "components/contact/ContactList";
import RequestHandler from "../../util/RequestHandler";
const { TabPane } = Tabs;

const UserAccountRoles = (props) => {
  const history = useHistory();
  const [bankListForTRY, setBankListForTRY] = useState([]);
  const [contactList, setContactList] = useState([]);
  const [drawerState, setDrawerState] = useState(false);
  const [isFullAccountChecked, setIsFullAccountChecked] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [checkboxDisabled, setCheckboxDisabled] = useState(false);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [tabKey,setTabKey] = useState(1);

  const [accountLoading, setAccountLoading] = useState(false);
  const [bankLoading, setBankLoading] = useState(false);

  const [showTosTab,setShowTosTab] = useState(false);
  const [tosAuthorizeList, setTosAuthorizeList] = useState([]);

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Hesap yetkilendirme işlemi başarılı!',
      duration: 2,
    });
  };

  const onContactSelect = (value) => {

    if(tabKey == 2) {
      RequestHandler.post(`/TosAuthorize/SetFullTosAuthorize`, {
        userId: props.match.params.userId
      }, false, { rawResponse: true }).then(res => {
          if (res.status == 200) {
            setIsFullAccountChecked(res.data)
            openNotificationWithIcon('success');
            setDisabled(res.data)
          }
       });
    }
    else {
      RequestHandler.post(`/User/AddFullAccountAuth`, { userId: props.match.params.userId }, false, { rawResponse: true }).then(res => {
          if (res.status == 200) {
            setIsFullAccountChecked(res.data.data.isFullAccountAuth)
            openNotificationWithIcon('success');
            setDisabled(res.data.data.isFullAccountAuth)
          }
        });
    }

  };

  const setAllSelectChecked = () => {
    const tenantAccountUsers = contactList.map((t) => ({
      tenantAccountId: t.id,
      tenantId: localStorage.getItem("tenantId"),
      userId: props.match.params.userId
    }));
    RequestHandler.post(`/TenantAccount/AddRangeTenantAccountUser`, tenantAccountUsers, false, { rawResponse: true }).then(response => {
      if (response.status == 200) {
        openNotificationWithIcon('success');
        getComp(contactList[0].bankId)
      }
    });
  }

  const onToggleDrawer = () => setDrawerState(true);

  const onToggleDrawerClose = () => setDrawerState(false);

  const getComp = (val, isChecked) => {
     if(tabKey == 2) {

      let listTosAuthorize;
      const existingItem = tosAuthorizeList.find(item => item.tenantPaymentAccountId === val);

      if (existingItem) {
        listTosAuthorize = tosAuthorizeList.map(item =>
          item.tenantPaymentAccountId === val
            ? { ...item, isAuthorize: isChecked }
            : item
        );
      } else {
        listTosAuthorize = [
          ...tosAuthorizeList,
          { tenantPaymentAccountId: val, isAuthorize: isChecked }
        ];
      }

      setTosAuthorizeList(listTosAuthorize);
      RequestHandler.get(`/TenantPaymentAccount?$filter=bankId eq ${selectedBankId}`).then((response) => {


      setContactList(response.value.map(model => {

          const matchedAuth = listTosAuthorize?.find(x => x.tenantPaymentAccountId === model.id);
          const isAuthorize = matchedAuth ? matchedAuth.isAuthorize : false;

          return {
          iban: model.iban,
          name: model.name,
          accountNumber: model.accountNumber,
          branchName: model.branchName,
          currency: model.currency,
          isAccountChecked: isAuthorize,
          id: model.id
        }}));

        setAccountLoading(false);
      });
    }
    else {
      RequestHandler.post(`/TenantAccount/GetWithTenantAccountUser`, {
        tenantId: localStorage.getItem("tenantId"),
        userId: props.match.params.userId,
        bankId: selectedBankId
      }, false).then(response => {
        setContactList(response);
        setAccountLoading(false);
      });
    }
  }

  useEffect(() => {
    RequestHandler.get(`/User/IsAdmin?userId=${props.match.params.userId}`).then(response => {
      setDisabled(response);
      setCheckboxDisabled(response);
    });


    RequestHandler.get(`/TosAuthorize/HasTosAuthorize?userId=${props.match.params.userId}`).then(response => {
      setShowTosTab(response);
    });

    setContactList([]);
    setSelectedBankId();
    setBankLoading(true);

    if(tabKey == 2) {

      RequestHandler.get(`/TosAuthorize/BankInfoAuthorize?userId=${props.match.params.userId}`).then(response => {
        setTosAuthorizeList(response);
      });

      RequestHandler.get(`/TosAuthorize/IsFullAccountAuth`, { userId: props.match.params.userId }, false).then(response => {
        setIsFullAccountChecked(response == true);
        setDisabled(response == true);
      });

      RequestHandler.get(`/TosBankInfo`).then(response => {
        setBankListForTRY(response.value.map(item => ({
          bankId: item.bankId,
          bankLogo: item.bankLogo
        })));

            setBankLoading(false);
      });
    }
    else {

      RequestHandler.post(`/User/IsFullAccountAuth`, { userId: props.match.params.userId }, false).then(response => {
        setIsFullAccountChecked(response.data);
        setDisabled(response.data);
      });

      RequestHandler.get(`/TenantAccount?$apply=groupby((BankLogo,BankId,BankCode),aggregate(Balance with sum as Balance))`).then(response => {
          setBankListForTRY(response);
          setBankLoading(false);
        });
    }

  }, [setIsFullAccountChecked, tabKey]);

  const goBankAccount = (value) => {
    setSelectedBankId(value)

    setAccountLoading(true);
    if(tabKey == 2) {
      RequestHandler.get(`/TenantPaymentAccount?$filter=bankId eq ${value}`).then((response) => {


       setContactList(response.value.map(model => {

        const matchedAuth = tosAuthorizeList?.find(x => x.tenantPaymentAccountId === model.id);
        const isAuthorize = matchedAuth ? matchedAuth.isAuthorize : false;

        return {
         iban: model.iban,
         name: model.name,
         accountNumber: model.accountNumber,
         branchName: model.branchName,
         currency: model.currency,
         isAccountChecked: isAuthorize,
        id: model.id
       }}))
       setAccountLoading(false);
      });
    }
    else {
      RequestHandler.post(`/TenantAccount/GetWithTenantAccountUser`, {
        tenantId: localStorage.getItem("tenantId"),
        userId: props.match.params.userId,
        bankId: value
      }, false).then(response => {
        setContactList(response);
        setAccountLoading(false);
      });
    }

  }
  const [form] = Form.useForm();
  const clearFilter = () => {

   setAccountLoading(true);
   form.resetFields();

   if(tabKey == 2) {
      RequestHandler.get(`/TenantPaymentAccount?$filter=bankId eq ${selectedBankId}`).then((response) => {


       setContactList(response.value.map(model => {

        const matchedAuth = tosAuthorizeList?.find(x => x.tenantPaymentAccountId === model.id);
        const isAuthorize = matchedAuth ? matchedAuth.isAuthorize : false;

        return {
         iban: model.iban,
         name: model.name,
         accountNumber: model.accountNumber,
         branchName: model.branchName,
         currency: model.currency,
         isAccountChecked: isAuthorize,
        id: model.id
       }}))

       setAccountLoading(false);
      });
    }
    else {
       RequestHandler.post(`/TenantAccount/GetWithTenantAccountUser`, {
        tenantId: localStorage.getItem("tenantId"),
        userId: props.match.params.userId,
        bankId: selectedBankId
      }, false).then(response => {
        setContactList(response);
        setAccountLoading(false);
      });
    }
  };
  const onFinish = (values) => {

    setAccountLoading(true);
    if(tabKey == 2) {

      const conditions = [];
      let query;

      if(values.iban) {
         conditions.push(`iban eq '${values.iban}'`);
      }

      if(values.accountNumber) {
        conditions.push(`accountNumber eq '${values.accountNumber}'`);
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }



      RequestHandler.get(`/TenantPaymentAccount?$filter=bankId eq ${selectedBankId} and ${query}`).then((response) => {


       setContactList(response.value.map(model => {

        const matchedAuth = tosAuthorizeList?.find(x => x.tenantPaymentAccountId === model.id);
        const isAuthorize = matchedAuth ? matchedAuth.isAuthorize : false;

        return {
         iban: model.iban,
         name: model.name,
         accountNumber: model.accountNumber,
         branchName: model.branchName,
         currency: model.currency,
         isAccountChecked: isAuthorize,
        id: model.id
       }}))

       setAccountLoading(false);
      });

    }
    else {
      RequestHandler.post(`/TenantAccount/GetWithTenantAccountUser`, {
        tenantId: localStorage.getItem("tenantId"),
        userId: props.match.params.userId,
        iban: values.iban,
        accountNumber: values.accountNumber
      }, false).then(response => {
        if (response.length != 0) {
          setContactList(response);
        } else {
          setContactList([]);
        }

        setAccountLoading(false);
      });
    }

  }

  const onTabChange = (tabKey) => {
    setSelectedBankId();
    setContactList([]);
     setTabKey(tabKey);
  };

  const ContactSideBar = () => {

    return <div className="gx-module-side">

       <Tabs defaultActiveKey="1" onChange={onTabChange}>
          <TabPane tab="Hesap Hareketleri" key="1" />
           <TabPane tab="TÖS" key="2" disabled={!showTosTab} />
        </Tabs>
      <div className="gx-module-side-header">
        <div className="gx-module-logo">
          <span>Kullanıcı Hesap Yetkileri </span>
        </div>
      </div>

      <div className="gx-module-side-content" style={disabled ? { pointerEvents: "none", opacity: "0.4" } : {}}>

        <CustomScrollbars className="gx-module-side-scroll">
          <div className="gx-module-add-task">

          </div>
          <div className="gx-module-side-nav">
            <ul className="gx-module-nav">
              <Spin spinning={bankLoading}>
                {bankListForTRY.map(option =>
                <li key={option.bankId} className="gx-nav-item" onClick={() => goBankAccount(option.bankId)}
                  style={{
                    cursor: 'pointer',
                    backgroundColor: selectedBankId === option.bankId ? '#bccae2' : 'transparent',
                    padding: '10px',
                    margin: '5px 0',
                    borderRadius: '5px'
                  }}
                >
                  <span
                    className={`gx-link`} >
                    <img style={{ width: '80%' }} src={option.bankLogo}  ></img>
                  </span>
                </li>
              )}
              </Spin>


            </ul>
          </div>
        </CustomScrollbars>
      </div>
    </div>

  };

  return (
    <div>
      <Row style={{ marginBottom: 9 }}>
        <Col flex={1}><a onClick={() => history.goBack()} style={{ color: 'black', marginLeft: "4%" }}> <RollbackOutlined /> GERİ DÖN</a></Col>
        <Col flex={4}></Col>
      </Row>
      <Row>
        <Col flex={1}> <p style={{ fontSize: '200%', marginLeft: "4%" }}><KeyOutlined /> HESAP YETKİLENDİRME</p><hr></hr><br></br></Col>
        <Col flex={4}>
          <div className="gx-module-box-topbar">
            <Checkbox className="gx-icon-btn"
              checked={isFullAccountChecked}
              value="checkedF"
              disabled={checkboxDisabled}
              onClick={(e) => onContactSelect(e.target.checked)} /> <p>Tüm Yetkiler</p>
          </div>
        </Col>
      </Row>
      <div className="gx-main-content">
        <div className="gx-app-module">
          <div className="gx-d-block gx-d-lg-none">
            <Drawer
              placement="left"
              width={100}
              closable={false}
              visible={drawerState}
              onClose={onToggleDrawerClose}>
              {ContactSideBar()}
            </Drawer>
          </div>
          <div className="gx-module-sidenav gx-d-none gx-d-lg-flex">
            {ContactSideBar()}
          </div>

          <div className="gx-module-box">
            <div className="gx-module-box-header">
              <span className="gx-drawer-btn gx-d-flex gx-d-lg-none">
                <i className="icon icon-menu gx-icon-btn" aria-label="Menu"
                  onClick={onToggleDrawer} />
              </span>

              <Row id="filterArea" >
                <Col span={24}>
                  <Collapse>
                    <Collapse.Panel header="Filtreleme için tıklayınız.">
                      <Form
                        name="filter"
                        form={form}
                        initialValues={{
                          remember: true,
                        }}
                        layout="vertical"
                        onFinish={onFinish}
                      >
                        <Row style={{ flexDirection: "row" }}>
                          <Col xs={24} md={12} lg={6}>
                            <Form.Item name="iban" label="IBAN :">
                              <Input allowClear />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12} lg={6}>
                            <Form.Item name="accountNumber" label="Hesap No :">
                              <Input allowClear />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row style={{ flexDirection: "row" }}>
                          <Col span={24} style={{ textAlign: "right" }}>
                            <Button
                              danger
                              size="small"
                              icon={<CloseOutlined />}
                              onClick={() => clearFilter()}
                            >
                              Sıfırla
                            </Button>
                            <Button
                              type="primary"
                              size="small"
                              icon={<SearchOutlined />}
                              style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                              htmlType="submit"
                            >
                              Filtrele
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Collapse.Panel>
                  </Collapse>
                </Col>
              </Row>
              {
                tabKey == 1 ? <> <div style={{ display: 'flex', alignItems: 'center', marginTop: "13px" }}>
                <Button
                  disabled={selectedBankId == undefined}
                  onClick={setAllSelectChecked} >Tümünü Seç</Button>
                 </div></> : <></>
              }

            </div>
            <div className="gx-module-box-content">

             <Spin spinning={accountLoading}>


                <CustomScrollbars className="gx-module-content-scroll">
                  {contactList.length === 0 ?
                    <div className="gx-h-100 gx-d-flex gx-align-items-center gx-justify-content-center">
                      Lütfen bir banka seçiniz
                    </div>
                    : <ContactList disabledPage={isFullAccountChecked} getDataComp={getComp} userId={props.match.params.userId} contactList={contactList} loading={accountLoading} tab={tabKey} />
                  }
                </CustomScrollbars>

              </Spin>

            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default UserAccountRoles;
